import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-logo-section">
            <img 
              src="/assets/Web Version/myersmcrae-logo-white.png" 
              alt="Myers McRae Executive Search and Consulting" 
              className="footer-logo"
            />
          </div>
          <div className="footer-company-info">
            <div className="company-name-address">
              <p className="company-name">Myers McRae Consulting LLC</p>
              <p className="company-address">116 Village Blvd Suite 200 Princeton, NJ 08540</p>
            </div>
            <div className="company-email-container">
              <a href="mailto:myersmcrae@myersmcrae.com" className="company-email">myersmcrae@myersmcrae.com</a>
            </div>
            <div className="company-contact-container">
              <span className="company-contact">
                Office: <a href="tel:+14783306222">+1 478 330 6222</a>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-middle">
        <div className="footer-container">
          <div className="footer-nav-column">
            <h3 className="footer-nav-title">About Us</h3>
            <ul className="footer-nav-list">
              <li><Link to="/our-history">Our History</Link></li>
              <li><Link to="/teams">Our Team</Link></li>
            </ul>
          </div>

          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Who We Serve</h3>
            <ul className="footer-nav-list">
              <li><Link to="/higher-education">Higher Education</Link></li>
              <li><Link to="/healthcare">Healthcare</Link></li>
            </ul>
          </div>

          <div className="footer-nav-column">
            <h3 className="footer-nav-title"><Link to="/current-searches">Current Searches</Link></h3>
          </div>

          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Our Services</h3>
            <ul className="footer-nav-list">
              <li><Link to="/services/executive-search">Executive Search and Placement Services</Link></li>
              <li><Link to="/services/ai-innovation">AI Innovation & Academic Modernization</Link></li>
              <li><Link to="/services/campus-safety">Campus Safety Audits: From Risk to Resilience</Link></li>
              <li><Link to="/services/executive-coaching">Executive Coaching for Academic Leaders</Link></li>
            </ul>
          </div>

          <div className="footer-nav-column">
            <h3 className="footer-nav-title">News & Insights</h3>
            <ul className="footer-nav-list">
              <li><Link to="/news-and-insights/recent-placements">Recent Placements</Link></li>
              <li><Link to="/news-and-insights/monthly-newsletters">Monthly Newsletters</Link></li>
              <li><Link to="/news-and-insights/our-success-stories">Our Success Stories</Link></li>
            </ul>
          </div>

          <div className="footer-nav-column">
            <h3 className="footer-nav-title"><Link to="/contact-us">Contact Us</Link></h3>
          </div>

          <div className="footer-nav-column">
            <h3 className="footer-nav-title">Connect with us</h3>
            <div className="footer-social-icons">
              {/* <a href="https://www.facebook.com/100080284851678/about/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <img 
                  src="/assets/Web Version/Icons/facebook-icon.svg" 
                  alt="Facebook" 
                  className="social-icon"
                />
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <img 
                  src="/assets/Web Version/Icons/twitter-icon.svg" 
                  alt="Twitter" 
                  className="social-icon"
                />
              </a> */}
              <a href="https://www.linkedin.com/company/myersmcrae/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <img 
                  src="/assets/Web Version/Icons/linkedin-icon.svg" 
                  alt="LinkedIn" 
                  className="social-icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        <div className="footer-container">
          <p className="footer-copyright">Copyright © 2026 Myers McRae. All Rights Reserved.</p>
          <div className="footer-legal">
            <Link to="/sitemap">Sitemap</Link>
            <span className="footer-legal-separator">|</span>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

